import { useMemo } from "react";

import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getScenarioModelListForWorkspaceQueryDocument } from "./scenario-model.gql";

export interface UseGetScenarioModelList {
  workspaceId: string;
  enabled?: boolean;
}

export const useGetScenarioModelList = ({ workspaceId, enabled = true }: UseGetScenarioModelList) => {
  const queryResult = useQuery({
    queryKey: queryKeys.scenarioModels.list(workspaceId),
    queryFn: async () => {
      if (!workspaceId) {
        throw new Error("Workspace ID is required");
      }
      const client = createOperationClient("GetScenarioModelListForWorkspace");
      const data = await client.request(getScenarioModelListForWorkspaceQueryDocument, { input: { workspaceId } });
      return data.scenarioModelListForWorkspace;
    },
    enabled: enabled && !!workspaceId,
    staleTime: 2 * 60 * 1000, // 2 minutes for list data
  });

  const scenarioModelList = useMemo(() => {
    return queryResult.data ?? [];
  }, [queryResult.data]);

  return {
    scenarioModelList,
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
  };
};
